import URLConfig from "@Config/urls/url.config";
import { LinkItemProps } from "@Layouts/sidebar/AppSidebar";

const URL_GLOBAL_PARAMETERS = URLConfig.CARD_MANAGEMENT_SYSTEM.PREPAID.GLOBAL_PARAMETERS;
const URL_CARD = URLConfig.CARD_MANAGEMENT_SYSTEM.PREPAID.CARD;
const URL_PREPAID_OPERATIONS = URLConfig.CARD_MANAGEMENT_SYSTEM.PREPAID.PREPAID_OPERATIONS;
const URL_COMPANY = URLConfig.CARD_MANAGEMENT_SYSTEM.PREPAID.COMPANY;
const URL_CARD_HOLDER = URLConfig.CARD_MANAGEMENT_SYSTEM.PREPAID.CARD_HOLDER;

export const GlobalParametersMenu: Array<LinkItemProps> = [
  {
    name: "Raison d'arrêt de la recharge automatique",
    link: URL_GLOBAL_PARAMETERS.AUTOMATIC_RECHARGE_STOP_REASON,
    level: 3,
  },
  {
    name: "Frais de recharge",
    link: URL_GLOBAL_PARAMETERS.RECHARGE_FEES,
    level: 3,
  },
  {
    name: "Frais periodiques divers",
    link: URL_GLOBAL_PARAMETERS.MISCELLANEOUS_PERIODIC_COSTS,
    level: 3,
  },
  {
    name: "Compte agence cartes anonymes",
    link: URL_GLOBAL_PARAMETERS.ANONYMOUS_CARD_AGENCY_ACCOUNT,
    level: 3,
  },
];

export const CardMenu: Array<LinkItemProps> = [
  {
    name: "Production de cartes anonymes",
    link: URL_CARD.ANONYMOUS_CARD_PRODUCTION,
    level: 3,
  },
  {
    name: "Consultation carte anonyme",
    link: URL_CARD.CONSULT_ANONYMOUS_CARD,
    level: 3,
  },
  {
    name: "Consultation transaction prépayée",
    link: URL_CARD.CONSULT_PREPAID_TRANSACTION,
    level: 3,
  },
];

export const PrepaidOperationsMenu: Array<LinkItemProps> = [
  {
    name: "Recharge manuelle de la carte",
    link: URL_PREPAID_OPERATIONS.MANUAL_CARD_TOP_UP,
    level: 3,
  },
  {
    name: "Activer la recharge automatique",
    link: URL_PREPAID_OPERATIONS.ENABLE_AUTOMATIC_RECHARGE,
    level: 3,
  },
  {
    name: "Arrêter la recharge automatique",
    link: URL_PREPAID_OPERATIONS.DISABLE_AUTOMATIC_RECHARGE,
    level: 3,
  },
];

export const CompanyMenu: Array<LinkItemProps> = [
  {
    name: "Données Entreprise",
    link: URL_COMPANY.COMPANY_DATA,
    level: 3,
  },
  {
    name: "Fichier salaire",
    link: URL_COMPANY.SALARY_FILE,
    level: 3,
  },
  {
    name: "Details fichier salaire",
    link: URL_COMPANY.SALARY_FILE_DETAILS,
    level: 3,
  },
];

export const CardHolderMenu: Array<LinkItemProps> = [
  {
    name: "Programme prépayé",
    link: URL_CARD_HOLDER.PREPAID_PROGRAM,
    level: 3,
  },
  {
    name: "Application prépayée",
    level: 3,
    subMenu: [
      {
        name: "Application prépayée",
        link: URL_CARD_HOLDER.PREPAID_APPLICATION.PREPAID_APPLICATION,
        level: 4,
      },
      {
        name: "Consultation application prépayée",
        link: URL_CARD_HOLDER.PREPAID_APPLICATION.CONSULT_PREPAID_APPLICATION,
        level: 4,
      },
    ]
  },
  {
    name: "Validation application prépayée",
    link: URL_CARD_HOLDER.PREPAID_APPLICATION_VALIDATION,
    level: 3,
  },
  {
    name: "Porteur anonyme",
    link: URL_CARD_HOLDER.ANONYMOUS_CARD_HOLDER,
    level: 3,
  },
  {
    name: "Consultation données prépayées",
    link: URL_CARD_HOLDER.CONSULT_PREPAID_DATA,
    level: 3,
  },
  {
    name: "Changer l'agence de la carte anonyme",
    link: URL_CARD_HOLDER.CHANGE_ANONYMOUS_CARD_AGENCY,
    level: 3,
  },
];

// export default GlobalParametersMenu;
